// 月別アーカイブのセレクト選択によるページ遷移
$('#sideArchiveSelect').on('change', function () {
  window.location = $(this).find('option:selected').val();
});